import { ReactNode, useCallback, useState } from 'react';
import { RenderIf } from 'react-rainbow-components';
import {
    BusinessHealthResponse,
    HealthScoreOverallStatus,
    PrimaryMetricsPresentation,
    QuestionKey,
} from '../../types';
import InsightDetailDrawer from './InsightDetailDrawer';
import InsightPrimaryMetrics from './InsightPrimaryMetrics';
import {
    QuestionInsightContainer,
    IconContainer,
    QuestionInsights,
    PrimaryMetricsContainer,
    DetailsTriggerContainer,
    DetailsTrigger,
} from './styled';

export interface InsightProps {
    questionKey: QuestionKey;
    icon: React.ReactNode;
    status: HealthScoreOverallStatus;
    question: ReactNode;
    headline: ReactNode;
    summary: ReactNode;
    insights?: ReactNode;
    scoreComponent: string;
    data?: BusinessHealthResponse;
    primaryMetrics: string[];
    metricsGroup: string;
    primaryMetricsPresentation?: PrimaryMetricsPresentation;
    drawerMetricKeys?: string[];
}

const Insight = ({
    questionKey,
    icon,
    status,
    question,
    headline,
    summary,
    insights,
    data,
    primaryMetrics,
    metricsGroup,
    scoreComponent,
    primaryMetricsPresentation = 'aggregate',
    drawerMetricKeys,
}: InsightProps) => {
    const [detailOpen, setDetailOpen] = useState(false);
    const openDetail = useCallback(() => setDetailOpen(true), []);
    const closeDetail = useCallback(() => setDetailOpen(false), []);

    return (
        <>
            <QuestionInsightContainer>
                <IconContainer $status={status}>
                    {icon}
                    {questionKey}
                </IconContainer>
                <QuestionInsights $status={status}>
                    <h3>{question}</h3>
                    <h5>{headline}</h5>
                    <p>{summary}</p>
                </QuestionInsights>
                <RenderIf isTrue={!!insights}>
                    <QuestionInsights>
                        <p>{insights}</p>
                    </QuestionInsights>
                </RenderIf>
                <PrimaryMetricsContainer>
                    <InsightPrimaryMetrics
                        data={data}
                        primaryMetrics={primaryMetrics}
                    />
                </PrimaryMetricsContainer>
                <DetailsTriggerContainer>
                    <DetailsTrigger type="button" onClick={openDetail}>
                        View details
                    </DetailsTrigger>
                </DetailsTriggerContainer>
            </QuestionInsightContainer>
            <InsightDetailDrawer
                isOpen={detailOpen}
                onRequestClose={closeDetail}
                metricsGroup={metricsGroup}
                scoreComponent={scoreComponent}
                primaryMetrics={primaryMetrics}
                presentation={primaryMetricsPresentation}
                drawerMetricKeys={drawerMetricKeys}
                data={data}
            />
        </>
    );
};

export default Insight;
